import { render, staticRenderFns } from "./DeliveryMenuBindDialog.vue?vue&type=template&id=22ed59f8&scoped=true"
import script from "./DeliveryMenuBindDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuBindDialog.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuBindDialog.vue?vue&type=style&index=0&id=22ed59f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ed59f8",
  null
  
)

export default component.exports